module.exports = __webpack_public_path__ + "static/bulb-1af2f40e91cfdc36bac7878a79df1378.jpg";